import {Tab} from "semantic-ui-react";
import * as React from "react";
import {SystemStatusMessageEdit} from "./SystemStatusMessageEdit";
import {SystemStatusMessageRaw} from "./SystemStatusMessageRaw";
import {ConfigContext} from "../../../context/ConfigContext";
import {clampTabIndex} from "../../../context/TabSession";

const panes = [
    {
        menuItem: 'mask', render: props => <Tab.Pane><SystemStatusMessageEdit
            isOpen={props.isOpen}
            onClose={props.onClose}
            message={props.message}
            onlyOwnCompany={props.onlyOwnCompany}
        /></Tab.Pane>
    },
    {
        menuItem: 'raw', render: props => <Tab.Pane><SystemStatusMessageRaw
            isOpen={props.isOpen}
            onClose={props.onClose}
            message={props.message}
            onlyOwnCompany={props.onlyOwnCompany}
        /></Tab.Pane>
    },
]

const SystemStatusMessageEditTab = props => {
    const context = React.useContext(ConfigContext);

    return <Tab
        {...props = props}
        panes={panes}
        defaultActiveIndex={clampTabIndex(context.tabSession.systemStatusMessageEditTab, panes)}
        onTabChange={(_, data) => {
            context.setSingleTabSession("systemStatusMessageEditTab", parseInt(data.activeIndex.toString()))
        }}
    />
}

export default SystemStatusMessageEditTab